/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Hero_CtaInputs */

const en_st_hero_cta = /** @type {(inputs: St_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the waitlist`)
};

const id_st_hero_cta = /** @type {(inputs: St_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar waitlist`)
};

/**
* | output |
* | --- |
* | "Join the waitlist" |
*
* @param {St_Hero_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_hero_cta = /** @type {((inputs?: St_Hero_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Hero_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_hero_cta(inputs)
	return en_st_hero_cta(inputs)
});